import React from "react";
import { Table as AntdTable, TablePaginationConfig } from "antd";
import { GetPopupContainer } from "antd/es/table/interface";
import { tableHeightResponsive } from "../common-components/component";
import './style.scss';
interface TableProps {
    columns: any;
    dataSource: any;
    bordered?: boolean;
    defaultPageSize?: number;
    defaultCurrent?: number;
    tableClassName?: string;
    pagination?: false | TablePaginationConfig;
    onChangePagination?: (page: number, pageSize: number) => void;
    components?: any;
    showSorterTooltip?: any;
    scroll?: any;
    rowKey?: string;
    loading?: boolean;
    rowLimit?: number;
    paginationClassName?: string;
    totalCount?: Count;
    pageSizeOptions?: number[] | string[];
    currentPage?: number | undefined;
    showSizeChanger?: boolean;
    getPopupContainer?: GetPopupContainer | undefined;
    onChangeTable?: any;
    tabletitle?: string;
    buttonTitle?: string;
    navigateTo?: string;
    hideOnSinglePage?: boolean;
    sorter?: any;
    setSorter?: any;
    setSortedInfo?: any;
    setFiltersState?: any;
    filtersState?: any;
    setFilter?: any;
    subpath?: string;
    setDataSource?: any;
    originalData?: any;
}
export interface Count {
    count: number;
    totalCount: number;
}
const Table: React.FC<TableProps> = (props) => {
    const { columns,
        dataSource,
        bordered,
        showSorterTooltip,
        getPopupContainer,
        pagination,
        tableClassName,
        onChangeTable,
        rowKey,
        loading
    } = props;

    const headers = {
        header: {
            cell: (props: any) => (
                <th
                    {...props}
                    style={{
                        ...props.style,
                        fontSize: '14px',
                        lineHeight: '22px',
                        fontWeight: '600',
                        color: '#565E6CFF',
                        backgroundColor: '#f2f2fd',
                        padding: '8px'
                    }} />
            )
        }
    };
    
    console.log('pagination',pagination);
    return (
        <AntdTable
            bordered={bordered}
            getPopupContainer={getPopupContainer}
            columns={columns}
            dataSource={dataSource}
            loading={loading}
            pagination={{
                total: props.totalCount?.totalCount || 0,
                showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} total entries`,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                ...pagination
            }}
            components={headers}
            className={`${dataSource?.length ? "" : "empty-data"} ${tableClassName}`}
            onChange={onChangeTable}
            rowKey={rowKey}
            scroll={{ x: 1000, y: tableHeightResponsive() }}
            rowClassName={(_, index) => (index % 2 === 0 ? 'odd-row' : 'even-row')}
            showSorterTooltip={showSorterTooltip}
        />
    );
};

export default Table;